import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHouseholdIncomeChartsDataContext } from './hooks/useHouseholdIncomeChartsDataContext';

export const FamilyIncome = () => {
    const { chartData } = useHouseholdIncomeChartsDataContext();


    return (
        <SimpleBars
            title={'Renda Familiar Total'}
            horizontal={false}
            subtitles={chartData?.familyIncome?.map((item) => item.description)}
            values={chartData?.familyIncome?.map((item) => item.total  ||  0)}
        />
    );
};
